import { render, staticRenderFns } from "./RevenueExpenses.vue?vue&type=template&id=0696f240&scoped=true&"
import script from "./RevenueExpenses.vue?vue&type=script&lang=js&"
export * from "./RevenueExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0696f240",
  null
  
)

export default component.exports